import QuoteApiClient from './QuoteApiClient';

export default QuoteApiClient;
